import { API } from './_client';

export const applicants = {
  list: (opts = {}) => API.get('/applicants', { params: opts }).then((r) => r.data),
  get: (id) => API.get(`/applicants/${id}`).then((r) => r.data),
  create: (payload) => API.post('/applicants', payload).then((r) => r.data),
  update: (id, patch) => API.patch(`/applicants/${id}`, patch).then((r) => r.data),
  remove: (id) => API.delete(`/applicants/${id}`).then((r) => r.data),
  linkMatter: (id, matterId) => API.post(`/applicants/${id}/link-matter`, { matter_id: matterId }).then((r) => r.data),
  backfill: () => API.post('/applicants/backfill').then((r) => r.data),
};

export const postLodgement = {
  list: (matterId) => API.get(`/post-lodgement/${matterId}`).then((r) => r.data),
  create: (matterId, payload) => API.post(`/post-lodgement/${matterId}`, payload).then((r) => r.data),
  update: (matterId, requestId, patch) => API.patch(`/post-lodgement/${matterId}/${requestId}`, patch).then((r) => r.data),
  reply: (matterId, requestId, payload) => API.post(`/post-lodgement/${matterId}/${requestId}/reply`, payload).then((r) => r.data),
  remove: (matterId, requestId) => API.delete(`/post-lodgement/${matterId}/${requestId}`).then((r) => r.data),
};
